import React, { useEffect, useState } from "react";
import { Logo } from "@/components/Logo";

const STORAGE_KEY = "hcc_age_verified";

export const AgeGate = () => {
  const [state, setState] = useState(() =>
    typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY) === "1" ? "verified" : "open"
  );
  const [showResponsible, setShowResponsible] = useState(false);

  useEffect(() => {
    if (state === "open" || state === "exited") {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [state]);

  if (state === "verified") return null;

  return (
    <div
      data-testid="age-gate"
      className="fixed inset-0 z-[80] flex items-center justify-center p-5 bg-[#111111]/88 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-label="Age verification"
    >
      <div className="w-full max-w-lg bg-[#F7F1E7] text-[#1c1713] px-8 sm:px-12 py-10 sm:py-12 text-center shadow-2xl">
        <div className="flex justify-center">
          <Logo width={132} testId="age-gate-logo" />
        </div>
        <div className="mx-auto mt-8 h-px w-14 bg-[#C7A45D]" />

        {state === "open" ? (
          <>
            <h2 className="hcc-serif text-2xl sm:text-3xl font-medium mt-7 leading-snug">
              Welcome to Hema Connoisseur Collections
            </h2>
            <p className="mt-5 text-sm font-light leading-relaxed text-[#1c1713]/70">
              This website contains information relating to alcoholic beverages and is intended for
              users who are of legal drinking age in their jurisdiction.
            </p>
            <div className="mt-8 flex flex-col gap-3">
              <button
                data-testid="age-gate-confirm"
                className="w-full py-3.5 bg-[#1c1713] text-[#F7F1E7] text-[11px] uppercase tracking-[0.22em] font-semibold hover:bg-[#4B0F1E] transition-colors duration-300"
                onClick={() => {
                  window.localStorage.setItem(STORAGE_KEY, "1");
                  setState("verified");
                }}
              >
                I am of legal drinking age
              </button>
              <button
                data-testid="age-gate-exit"
                className="w-full py-3.5 border border-[#1c1713]/25 text-[#1c1713]/70 text-[11px] uppercase tracking-[0.22em] hover:border-[#1c1713] transition-colors duration-300"
                onClick={() => setState("exited")}
              >
                Exit website
              </button>
            </div>
            <button
              data-testid="age-gate-responsible-link"
              className="mt-6 text-[11px] tracking-[0.14em] uppercase text-[#4B0F1E] underline underline-offset-4 decoration-[#C7A45D]"
              onClick={() => setShowResponsible((v) => !v)}
            >
              Responsible Communication
            </button>
            {showResponsible && (
              <p data-testid="age-gate-responsible-copy" className="mt-4 text-[12px] font-light leading-relaxed text-[#1c1713]/60 text-left">
                Hema Connoisseur Collections presents alcoholic beverage information for corporate and
                trade purposes only. Our communication is factual and restrained, and is not intended
                to encourage excessive consumption or to address persons below legal drinking age.
              </p>
            )}
          </>
        ) : (
          <div data-testid="age-gate-exit-notice">
            <h2 className="hcc-serif text-2xl sm:text-3xl font-medium mt-7 leading-snug">Thank you for visiting</h2>
            <p className="mt-5 text-sm font-light leading-relaxed text-[#1c1713]/70">
              This website is intended for visitors of legal drinking age in their jurisdiction. We
              appreciate your understanding.
            </p>
            <button
              data-testid="age-gate-return"
              className="mt-8 text-[11px] uppercase tracking-[0.2em] text-[#4B0F1E] underline underline-offset-4 decoration-[#C7A45D]"
              onClick={() => setState("open")}
            >
              Return
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
